<div class="schedule-controls-bar">

    <!-- Wrap group 1 (Ray: date/today/arrows stay together on the first
         line). The date picker first (Ray: LEFT of the controls), then Today
         / < >, then the range-mode granularity presets. The pill drives the
         bar's own window through the shared ScheduleControlsService signals;
         the bar and the tabs stay in lockstep. -->
    <div class="bar-controls">
        <app-crumb-date-picker class="controls-date-picker"></app-crumb-date-picker>

        <button
            pButton
            label="Today"
            [outlined]="true"
            class="controls-same-height"
            (click)="goToday()"
            data-cy="controls-today-button"
        ></button>

        <p-buttonGroup class="date-action-buttons">
            <button
                pButton
                icon="pi pi-angle-left"
                [outlined]="true"
                [text]="true"
                size="large"
                (click)="step(-1)"
                aria-label="Previous"
                data-cy="controls-previous-button"
            ></button>
            <button
                pButton
                icon="pi pi-angle-right"
                [outlined]="true"
                [text]="true"
                size="large"
                (click)="step(1)"
                aria-label="Next"
                data-cy="controls-next-button"
            ></button>
        </p-buttonGroup>

        <!-- Day / Week / Month as tab-like segmented control (range-capable tabs) -->
        <p-selectButton
            *ngIf="isRangeMode && config?.granularities?.length"
            [options]="config.granularities"
            [(ngModel)]="granularityModel"
            class="granularity-tabs"
            [allowEmpty]="false"
        ></p-selectButton>
    </div>

    <!-- Spacer keeps the strip and the action icons right-aligned. -->
    <span class="controls-gap"></span>

    <!-- The active tab's summary strip (pacing / forecast / availability —
         Ray: moved OUT of the schedule card into the header, left of the
         filter button, so the calendar butts the panel's top edge). The
         tab publishes ControlsSummary on the service; absent = nothing
         renders (tabs without a summary never set it). When the bar wraps,
         this host flattens (display: contents) so its money and capacity
         groups become ordered wrap lines — see the @container rules. -->
    <app-daily-summary
        *ngIf="controls.summary() as summary"
        class="controls-summary"
        [stats]="summary.stats"
        [totalRevenue]="summary.totalRevenue"
        [showForecast]="summary.showForecast"
        [showPacing]="summary.showPacing"
        [isDayView]="summary.isDayView"
        [forceShowRevenue]="summary.forceShowRevenue"
        [prophetMetrics]="summary.prophetMetrics"
        [allDays]="summary.allDays"
        (filterByType)="runSummaryFilter($event)"
    ></app-daily-summary>

    <!-- Wrap group 2: the row's small controls — tab-specific actions
         (dispatch: Assign Crew / Send schedule) then the icon buttons -->
    <div class="bar-icons">
        <ng-container *ngFor="let action of config?.actions || []">
            <p-splitButton
                *ngIf="action.split"
                [label]="action.label"
                [icon]="action.icon"
                [outlined]="!action.filled"
                [disabled]="!!action.loading"
                [model]="action.menuItems ? action.menuItems() : null"
                (onClick)="action.onClick()"
                class="controls-action hide-on-bar-mobile"
                [attr.data-cy]="'controls-action-' + action.id"
            ></p-splitButton>
            <button
                *ngIf="!action.split"
                pButton
                [label]="action.label"
                [icon]="action.icon"
                [outlined]="!action.filled"
                (click)="action.onClick()"
                class="controls-same-height hide-on-bar-mobile"
                [attr.data-cy]="'controls-action-' + action.id"
            ></button>
        </ng-container>

        <!-- Filters (day view's event/asset-type filters; the tab opens its own
             overlay — the button just anchors it, so it sits above the tabs like
             the other controls, Ray). -->
        <ng-container *ngIf="config?.onFilters">
            <span class="p-overlay-badge">
                <button
                    pButton
                    icon="pi pi-filter"
                    [outlined]="true"
                    (click)="runFilters($event)"
                    aria-label="Open filters"
                    data-cy="controls-filter-button"
                ></button>
                <span *ngIf="(config.filtersBadge?.() ?? 0) > 0" class="p-badge p-badge-danger">{{ config.filtersBadge?.() }}</span>
            </span>
        </ng-container>

        <!-- Edit (day view only) sits LEFT of the gear; gear then refresh. -->
        <button
            *ngIf="showPencil"
            pButton
            icon="pi pi-pencil"
            [outlined]="true"
            (click)="runEdit()"
            aria-label="Edit"
            pTooltip="Edit Mode"
            tooltipPosition="bottom"
            data-cy="controls-edit-button"
        ></button>

        <ng-container *ngIf="showGear">
            <!-- No margin class here: the bar's flex gap is the single source of
                 spacing (request — gear/refresh used to read a wider gap than
                 the rest of the row). -->
            <button
                pButton
                icon="pi pi-cog"
                [outlined]="true"
                (click)="toggleGear($event)"
                aria-label="Settings"
                data-cy="controls-gear-button"
            ></button>
            <p-menu
                #gearMenu
                [popup]="true"
                [model]="config.gearMenu"
                appendTo="body"
            ></p-menu>
        </ng-container>

        <button
            *ngIf="showRefresh"
            pButton
            icon="pi pi-refresh"
            [class.controls-refresh-spinning]="controls.refreshing()"
            [outlined]="true"
            [disabled]="controls.refreshing()"
            (click)="runRefresh()"
            aria-label="Refresh"
            data-cy="controls-refresh-button"
        ></button>
    </div>

</div>